<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 10.75L5.75 5.75L0.750001 0.75" stroke="#9FABBE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
